export interface Testimonials {
  id: string;
  text: string;
  person: string;
}

export interface Gallery {
  id: string;
  image: string;
  text: string;
}

export interface NavItems {
  title: string;
  hash: string;
}

export interface ContactForm {
  firstname: string,
  emailaddress: string,
  company: string,
  comment: string,
}

export interface Service {
  id: string;
  title: string;
  body: string;
}

export enum RouteNames {
  Home = 'home',
  Gallery = 'gallery',
}

export interface Image {
  url: string;
}

export interface GalleryImage {
  id: string;
  altTag: string;
  image: Image;
}

export interface Asset {
  id: string;
  fileName: string;
  url: Image;
}
